import Loadable from '../../components/loadable';

const PendingCancellationsReport = Loadable({
  loader: () => import('../../pages/reports/pending_cancellations_report'),
});

angular.module('gym').value('PendingCancellationsReport', PendingCancellationsReport);

const PendingCancellationsReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/pending_cancellations_report/pending_cancellations_report_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('PendingCancellationsReportFiltersModal', PendingCancellationsReportFiltersModal);
